import type { SxProps, Theme } from '@mui/material';

export const faceDownCardRootSx = (selected: boolean): SxProps<Theme> => ({
  cursor: 'pointer',
  width: { xs: 56, sm: 72, md: 88, lg: 104 },
  aspectRatio: '300 / 527',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.2s ease',
  border: '2px solid transparent',
  backgroundColor: 'background.default',
  opacity: selected ? 1 : 0.85,
  transform: selected ? 'scale(1.05)' : 'scale(1)',
  borderColor: selected ? 'primary.main' : 'transparent',
  boxShadow: selected ? '0 0 16px rgba(224, 200, 120, 0.4)' : 'none',
  position: 'relative',
  '&:hover': {
    opacity: 1,
    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
  },
  '&:focus': {
    outline: 'none',
    boxShadow: '0 0 0 3px rgba(224, 200, 120, 0.5)',
  },
});

export const faceDownCardMediaSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block',
};

export const faceDownCardSelectedIndicatorSx: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: 'primary.main',
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const faceDownCardIconSx: SxProps<Theme> = {
  fontSize: 32,
};
